<div [dialogRef]="dialog" (appClickOutside)="close()">
  <div [appEnforcePermission]="authConfig.investigationScheduledDateUpdateAll"
    #investigationScheduledDateUpdateAll="appEnforcePermission"></div>

  <kendo-dialog-titlebar (close)="close()">
    <div class="modal-title">
      <span>Edit On Scene History</span>
      <ng-container *ngIf="investigationOnScene?.Investigation.nefcoNumber">
        <p class="modal-subtitle mb-12 mt-12">Investigation ID: {{investigationOnScene?.Investigation?.nefcoNumber}}</p>
        <p class="modal-subtitle mb-12">Timezone: {{(investigationOnScene?.Investigation?.timezone | timezonePipe) || '-'}}</p>
      </ng-container>
    </div>
  </kendo-dialog-titlebar>
  <div class="model-body">
    <kendo-gridlayout class="contact-info-wrapper mt-16 mb-16" [rows]="['auto']" [gap]="{rows: 5, cols: 0}"
      [cols]="['repeat(6,minmax(0,1fr))']">
      <kendo-gridlayout-item class="mb-0 p-16" [colSpan]="2">
        <div>
          <h6>Staff</h6>
          <p class="staff-name">{{ investigationOnScene?.User | fullName : false }}</p>
        </div>

      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="mb-0 p-16" colSpan="4">
        <div>
          <h6>Scheduled Date & Time</h6>
          <p class="date-time">
            {{ investigationOnScene?.scheduledDate | dateWithTimezone : "MM-DD-YYYY" :
            investigationOnScene?.Investigation?.timezone }} at
            {{ investigationOnScene?.scheduledDate | dateWithTimezone : 'hh:mm:ss A' :
            investigationOnScene?.Investigation?.timezone }}
          </p>
        </div>
      </kendo-gridlayout-item>
    </kendo-gridlayout>

    <p class="warning-message mb-16 mt-16">
      Enter the entry date/time and status of on scene status.<br />
    </p>
    <form #frm="ngForm" autocomplete="off" *ngIf="investigationScheduledDateUpdateAll?.enabled">
      <section *ngIf="onScenes?.length">
        <kendo-gridlayout [rows]="['auto']" [gap]="{ rows: 5, cols: 16 }" [cols]="['repeat(10,minmax(0,1fr))'] ">
          <ng-container
            *ngFor="let item of onScenes; let index = index; let first = first; let last = last trackBy: trackByIndex">
            <kendo-gridlayout-item [colSpan]="3">
              <kendo-formfield>
                <kendo-label class="asterisk" text="Entry Date"></kendo-label>
                <kendo-datetimepicker calendarType="classic" [fillMode]="'outline'" [name]="'createdAt_' + index"
                  #createdAt="ngModel" [(ngModel)]="onScenes[index].createdAt" placeholder="Enter entry date"
                  format="MM-dd-yyyy hh:mm a" formatPlaceholder="formatPattern" required></kendo-datetimepicker>
                <kendo-formerror>
                  <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                  <span *ngIf="!createdAt?.valid && (createdAt?.dirty || createdAt?.touched)">Entry date cannot be
                    left
                    blank</span>
                </kendo-formerror>
              </kendo-formfield>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [colSpan]="3">
              <kendo-formfield class="kendo-formfield">
                <kendo-label class="asterisk" text="Status"></kendo-label>
                <kendo-dropdownlist [data]="investigationOnSceneStatusAll" fillMode="outline" [name]="'status_' + index"
                  placeholder="Select Status" #status="ngModel" [valuePrimitive]="true"
                  [(ngModel)]="onScenes[index].status"
                  [popupSettings]="{appendTo: 'component', animate: false, width: 250 }" required>
                </kendo-dropdownlist>
                <kendo-formerror *ngIf="!status?.valid && (status?.dirty || status?.touched)">
                  <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                  <span *ngIf="status?.errors?.required">
                    Status cannot be left blank
                  </span>
                </kendo-formerror>
              </kendo-formfield>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [colSpan]="3">
              <div class="kendo-formfield">
                <kendo-label text="Source"></kendo-label>
                <kendo-textbox name="source" fillMode="outline" [disabled]="true" [value]="onScenes[index]?.source">
                </kendo-textbox>
              </div>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item class="actions" [colSpan]="1">
              <span class="k-icon k-i-minus-outline" style="margin-top: 33px;margin-left: 16px;"
                *ngIf="!onScenes[index]?.id" (click)="removeEntry(index)"></span>
            </kendo-gridlayout-item>
            <!-- <kendo-gridlayout-item colSpan="2">
              <kendo-formfield>
                <kendo-label class="asterisk" text="Scheduled Time"></kendo-label>
                <kendo-timepicker required="true" format="hh:mm a" [name]="'time_' + index" #scheduledTime="ngModel"
                  [(ngModel)]="scheduledFormEntry[index].scheduledTime" placeholder="Enter time"></kendo-timepicker>
                <kendo-formhint>(ie, HH:MM)</kendo-formhint>
                <kendo-formerror>
                  <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                  <span *ngIf="!scheduledTime?.valid && (scheduledTime?.dirty || scheduledTime?.touched)">Time cannot be
                    left blank</span>
                </kendo-formerror>
              </kendo-formfield>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item class="actions" colSpan="1">
              <span class="k-icon k-i-minus-outline" style="margin-top: 33px;margin-left: 16px;"
                *ngIf="mode !== 'NEW_SCHEDULE_CALENDAR' && mode !== 'EDIT_PENDING_SCHEDULE_CALENDAR'"
                (click)="removeScheduledEntry(index)"></span>
            </kendo-gridlayout-item> -->
          </ng-container>
        </kendo-gridlayout>
        <button kendoButton class="mr-24" icon="plus-circle" themeColor="primary" fillMode="link"
          (click)="addOnScene()">Add Status Entry</button>
      </section>
    </form>
  </div>
  <kendo-dialog-actions class="schedule-action p-16-24" layout="end">
    <button kendoButton [size]="'medium'" themeColor="light" class="kendo-btn" class="mr-16" (click)="close()">
      Cancel
    </button>
    <button kendoButton class="kendo-btn" [size]="'medium'" themeColor="primary" (click)="submit()">
      Save
    </button>
  </kendo-dialog-actions>

</div>
